<template>
  <div :class="title ? 'main--container' : 'main--container-without-title'">
    <div class="not-italic font-normal text-zt-xl leading-8 flex items-center text-zt-primary-200">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'HeaderPickup',
  props: {
    title: {
      default: '',
      type: String
    },
    subtitle: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      items: [
        {
          text: this.$t("message.menuComponent.item0"),
          to: '/main',
          disabled: false
        },
        {
          text: this.$t("message.UploadLanding.pickup.titleSing"),
          to: '#',
          disabled: true
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.main--container {
  padding-top: 10px;
}

.main--container-without-title {
  position: absolute;
  top: 10px;
  z-index: 10000000;
}

.main--btn {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-left: 16px;
}

.main-title {
  line-height: 32px;
  padding-left: 10px;
}

.main--label {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #9ca6e2;
  padding-left: 8px;
}
</style>
